// Resize callbacks must not change layout or add observed ancestors while the
// browser is delivering notifications. Coalesce measurements into the next frame.
export function observeMapResize(elements: Element[], measure: () => void) {
  let frame: number | undefined
  let disposed = false
  const schedule = () => {
    if (disposed || frame !== undefined) return
    frame = requestAnimationFrame(() => {
      frame = undefined
      if (!disposed) measure()
    })
  }
  const observer = new ResizeObserver(schedule)
  for (const element of new Set(elements)) observer.observe(element)
  // Mapbox attaches control portals after their children mount.
  schedule()
  return () => {
    disposed = true
    observer.disconnect()
    if (frame !== undefined) cancelAnimationFrame(frame)
  }
}
